import axios from "axios";
import qs from 'qs';
import { handlerError } from "utils";
import { notification } from 'antd';

export const saveSolicitation = async (id, status, invoiceUrl, value) => {
    try {
        const req = {
            data: {
                value: value,
                status: status,
                invoiceUrl: invoiceUrl
            }
        }
        await axios.put(`/solicitation/${id}`, req);
        notification.success({
            message: "Pedido salvo com sucesso"
        })
    } catch (ex) {
        handlerError(ex);
        throw (null);
    }
};

export const updateSolicitation = async (id, body) => {
    try {
        await axios.put(`/solicitation/${id}`, body);
        notification.success({
            message: "Datas atualizadas com sucesso",
        })
    } catch (ex) {
        handlerError(ex);
        throw (null);
    }
};

export const getAllSolicitation = async (filter = null) => {
    try {
        const formatFilter = filter ? filter.replace(".", "").replace(",", ".") : undefined
        const { data } = await axios.get(`/solicitation`, { params: { filter: formatFilter } });
        return data.data && data.data.length > 0 ? data.data : [];
    } catch (ex) {
        handlerError(ex);
        return [];
    }
};

export const getIncomes = async (filter = null, listAll = false, dateRange = null, page = null, pageSize = null, silent = false) => {
    try {
        const formatFilter = filter ? filter.replace(".", "").replace(",", ".") : undefined;
        const { data } = await axios.get(`/solicitation/incomes`, {
            params: {
                filter: formatFilter,
                listAll,
                dateRange,
                ...(page != null ? { page } : {}),
                ...(pageSize != null ? { size: pageSize } : {}),
            }
        });
        return {
            data: data.data && data.data.length > 0 ? data.data : [],
            total: data.total ?? 0,
        };
    } catch (ex) {
        if (!silent) handlerError(ex);
        return { data: [], total: 0, error: true };
    }
};

const INCOME_SKIP_REASONS = {
    NOT_FOUND: "não encontrado",
    FORBIDDEN: "sem permissão",
    COMPLETED: "já concluído",
    CANCELED: "já cancelado",
    ALREADY_PROCESSING: "já está em cancelamento",
    ENQUEUE_FAILED: "falha ao enfileirar (pode tentar de novo)",
};

const summarizeSkipped = (skipped) => {
    const counts = skipped.reduce((acc, item) => {
        const label = INCOME_SKIP_REASONS[item.reason] ?? item.reason;
        acc[label] = (acc[label] ?? 0) + 1;
        return acc;
    }, {});
    return Object.entries(counts).map(([label, total]) => `${total} ${label}`).join("; ");
};

export const cancelIncomes = async (incomes = []) => {
    try {
        const { data } = await axios.post(`/solicitation/incomes/cancel`, { incomes });

        if (!Array.isArray(data.accepted)) {
            notification.success({
                message: "Pedidos cancelados com sucesso",
            })
            return { accepted: incomes, skipped: [] };
        }

        const accepted = data.accepted;
        const skipped = data.skipped ?? [];
        if (accepted.length > 0) {
            notification.success({
                message: `${accepted.length} pedido(s) enviado(s) para cancelamento`,
                description: "O cancelamento é processado em segundo plano. Acompanhe o status na lista.",
            })
        }
        if (skipped.length > 0) {
            notification.warning({
                message: `${skipped.length} pedido(s) não enviado(s)`,
                description: summarizeSkipped(skipped),
            })
        }
        return { accepted, skipped };
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const getByIdSolicitation = async (id) => {
    try {
        const { data } = await axios.get(`/solicitation/${id}`);
        return data.solicitation ? data.solicitation : null;
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const getAllSolicitationStatus = async () => {
    try {
        const { data } = await axios.get(`/solicitation/status`);
        return data.status ? data.status : [];
    } catch (ex) {
        handlerError(ex);
        return [];
    }
};

export const cancelSolicitation = async (id) => {
    try {
        const { data } = await axios.post(`/solicitation/${id}/cancel`);
        notification.success({
            message: "Pedido cancelado com sucesso",
        })
        return true;
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const approveSolicitation = async (id) => {
    try {
        const { data } = await axios.put(`/solicitation/${id}/approve`, { forceRun: true });
        notification.success({
            message: "Pedido aprovado com sucesso",
        })
        return true;
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const getBankSplit = async (id) => {
    try {
        const { data } = await axios.post(`/solicitation/${id}/createBankSlip`);
        return data.solicitation ? data.solicitation : null;
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const getPixQRCode = async (id) => {
    try {
        const { data } = await axios.post(`/solicitation/${id}/createPixQRCode`);
        return data.solicitation ? data.solicitation : null;
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const getPaySchedule = async (id) => {
    try {
        const { data } = await axios.put(`/solicitation/${id}/schedule/pay`);
        return data;
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const getChargeLines = async (id) => {
    try {
        const { data } = await axios.get(`/solicitation/${id}/entries`);
        return data.entries ? data.entries : [];
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const getfeeLines = async (id) => {
    try {
        const { data } = await axios.get(`/solicitation/${id}/fees`);
        return data.fees ? data.fees : [];
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const getAdmFeeLines = async (id) => {
    try {
        const { data } = await axios.get(`/solicitation/${id}/adm/fees`);
        return {
            chargeFee: data.chargeFee? data.chargeFee : 0,
            partChargeFee: data.partChargeFee? data.partChargeFee : 0,
            fees: data.fees ? data.fees : []
        };
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};


export const cancelChargeLines = async (id, data) => {
    try {
        await axios.put(`/solicitation/${id}/entries/cancel`, { entries: data });
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const getChargeLinesIN = async (ids) => {
    try {
        const { data } = await axios.get(`/solicitation/entries`, {
            params: { ids: ids },
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' })
        });
        return data.entries ? data.entries : [];
    } catch (ex) {
        handlerError(ex);
        return [];
    }
};

export const getRefundLines = async (id) => {
    try {
        const { data } = await axios.get(`/solicitation/${id}/refunds`);
        return data.list ? data.list : [];
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const getTreasury = async (date) => {
    try {
        const { data } = await axios.get(`/solicitation/treasury?date=${date}`);
        return data.data ? data.data : [];
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const getInvoiceById = async (id) => {
    try {
        const { data } = await axios.get(`/solicitation/invoice/${id}`);
        return data;
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const approveSolicitations = async () => {
    try {
        await axios.post(`/solicitation/approve-solicitation`);
        notification.success({
            message: "Operação realizada com sucesso",
        })
    } catch (ex) {
        handlerError(ex);
    }
};

export const createInvoice = async (id) => {
    try {
        await axios.post(`/solicitation/${id}/invoice`);
        notification.success({
            message: "Nota de débito gerada com sucesso",
        })
    } catch (ex) {
        handlerError(ex);
        throw (null);
    }
};

export const genericCheckout = async (request, body, success) => {
    try {
        const { data } = await axios({
            method: request.method,
            url: request.url,
            data: body
        });
        notification.success({
            message: success,
        })
        return data && data.solicitation ? data.solicitation.id : (data && data.data? data.data: null);
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const getValidationSolicitation = async (id) => {
    try {
        const { data } = await axios.get(`/solicitation/${id}/status`);
        return data.solicitation ? data.solicitation : {};
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const redeemLine = async (body) => {
    try {
        await axios.post(`/solicitation/${body.solicitation}/line/redeem`, {
            data: {
                user: body.user,
                benefit: body.benefit
            }
        });
        notification.success({
            message: "Linha resgatada com sucesso!",
        })
    } catch (ex) {
        handlerError(ex);
        throw (null);
    }
};

export const getSavedSolicitations = async () => {
    try {
        const { data } = await axios.get(`/solicitation/template`);
        return data.solicitationTemplates ? data.solicitationTemplates : [];
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const removeSavedSolicitation = async (id) => {
    try {
        await axios.delete(`/solicitation/template/${id}`);
        notification.success({
            message: "Gerente de segmentações removido com sucesso!",
        })
    } catch (ex) {
        handlerError(ex);
        return {};
    }
};

export const forceCharge = async (solicitationID, userIDs) => {
		try {
				await axios.post(`/solicitation/${solicitationID}/force`, { users: userIDs });
        notification.success({
            message: "Retentativa feita com sucesso!",
        });
		} catch (ex) {
				handlerError(ex);
			return null;
		}
}

export const saveCorporateSolicitation = async (data) => {
    try {
        await axios.post('/solicitation/corporate', data);
        notification.success({ message: 'Pedido corporativo salvo com sucesso' });
    } catch (ex) {
        handlerError(ex);
        throw null;
    }
};
